import React from "react";
import PropTypes from "prop-types";
import Base from "../Base";
import Icon from "components/common/MaterialIcon";
import { Input } from "antd";

@autobind
/**
 *
 */
export default class Text extends Base {
  static propTypes = {
    ...Base.propTypes,
    value: PropTypes.string,
    haveIcon: PropTypes.bool
  };

  static defaultProps = {
    haveIcon: true,
  }

  /**
   *
   * @return {XML}
   * @protected
   */
  get _component() {
    return (
      <Input
        prefix={this.props.haveIcon ? <Icon name="alphabetical" />: ''}
        type="text"
        dir="auto"
      />
    );
  }
}
